import { MenuEntry } from 'boltr-uikit'
import { LinkStatus } from '@pancakeswap-libs/eslint-config-pancake'

const status = {
  LIVE: <LinkStatus>{
    text: "LIVE",
    color: "failure",
  },
  SOON: <LinkStatus>{
    text: "SOON",
    color: "warning",
  },
  NEW: <LinkStatus>{
    text: "NEW",
    color: "success",
  },
};

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://app.boltrswap.com/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    initialOpenState: true,
    items: [
      {
        label: 'Exchange',
        href: '/swap',
      },
      {
        label: 'Liquidity',
        href: '/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: 'https://farm.boltrswap.com/farms',
    status: status.LIVE
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    href: 'https://farm.boltrswap.com/pools',
    status: status.LIVE
  },
  {
    label: 'NFT',
    icon: 'NftIcon',
    href: '#',
    status: status.SOON
  },
  {
    label: 'IFO',
    icon: 'IfoIcon',
    href: '#',
    status: status.SOON
  },
  {
    label: 'Analytics',
    icon: 'InfoIcon',
    href: 'https://analytics.boltrswap.com/',
    status: status.LIVE
  },
  {
    label: 'Audit',
    icon: 'TeamBattleIcon',
    items: [
      {
        label: '0xGuard Audit',
        href: 'https://boltrswap.gitbook.io/boltr/boltr-documentations/security-audit',
		status: status.NEW
      },
      {
        label: 'Certik Audit',
        href: 'https://www.certik.org/#',
		status: status.SOON
      },
      {
        label: 'Hacken Audit',
        href: 'https://hacken.io/#',
		status: status.SOON
      },
    ],
  },
  {
    label: 'Listings',
    icon: 'GroupsIcon',
    items: [
      {
        label: 'CoinMarketCap',
        href: 'https://coinmarketcap.com/currencies/#',
		status: status.SOON
      },
      {
        label: 'CoinGecko',
        href: 'https://www.coingecko.com/en/coins/#',
		status: status.SOON
      },
      {
        label: 'Poocoin',
        href: 'https://polygon.poocoin.app/tokens/0x8b661d59f1923b138e0048ff5ed5b8fef6f9e5cf',
		status: status.NEW
      },
      {
        label: 'Vfat',
        href: 'https://vfat.tools/polygon/boltrswap',
		status: status.NEW
      },
    ],
  },
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: 'Github',
        href: 'https://github.com/boltrswap',
      },
      {
        label: 'Docs',
        href: 'https://boltrswap.gitbook.io/boltr/',
      },
      {
        label: 'Blog',
        href: 'https://boltr.medium.com/',
      },
    ],
  },
]

export default config
